export default "__VITE_ASSET__26b184a5__"